import React, { useCallback, useState } from 'react'

import { ButtonContainer } from 'styles/shared'
import styled from 'styled-components'
import { color } from 'styles/colors'

import Modal from 'components/Modal'
import ModalButton from 'components/Modal/Button'

import Apptentive from 'helpers/apptentive'
import GA4 from 'helpers/ga4'

import Api from 'services/api'

type Props = {
  channel: string
  dealerId: number
  closeCallback: (reload: boolean) => void
}

const CANCELLATION_MESSAGE = 'If you cancel, you will lose access to all installed HVAC Performance Monitoring Kits on your account.  Your account will be disabled immediately, and you will no longer be billed for existing HVAC Performance Monitoring Kits on your account. \n\nYou will also no longer be able to install any new HVAC Performance Monitoring Kits.'

const HEHMCancelModal = ({ channel, dealerId, closeCallback } : Props) => {
  const [isSaving, setIsSaving] = useState(false)

  const onClickCancel = useCallback(async () => {
    setIsSaving(true)
    await Api.Paywall.cancelPlan(dealerId, 'hehm')
      .then(() => {
        Apptentive.sendEvent('pmk_acct_canceled')
        GA4.sendEvent({ category: 'PMK Settings', action: 'PMK Account Deactivated', label: `Channel: ${channel}` })

        closeCallback(true)
      }).catch(() => setIsSaving(false))
  }, [closeCallback, dealerId, channel])

  const onClickClose = () => {
    closeCallback(false)
  }

  return (
    <Modal variant="sm" isDisplayed closeCallback={() => closeCallback(false)} title="Cancel Plan">
      <S.Top />
      <S.Form>
        <S.Explanation>{CANCELLATION_MESSAGE}</S.Explanation>
      </S.Form>
      <S.ButtonContainer>
        <ModalButton
          decoration="secondary"
          text="Cancel Plan"
          onPress={onClickCancel}
          showSpinner={isSaving}
          styles={{ button: { height: 32, borderRadius: 10, width: 120 } }}
        />
        <ModalButton
          decoration="positive"
          text="Close"
          onPress={onClickClose}
          styles={{ button: { height: 32, borderRadius: 10, width: 120 } }}
        />
      </S.ButtonContainer>
    </Modal>
  )
}

export default HEHMCancelModal

const S = {
  ButtonContainer: styled(ButtonContainer)`
    border-top: none;
    max-width: 800px;
    margin-top: 0px;
  `,
  Explanation: styled.div`
    display: flex;
    margin-bottom: 20px;
    text-align: left;
    color: ${color('premiumText')};
    white-space: pre-line;
  `,
  Form: styled.form`
    display: flex;
    grid-column-gap: 50px;
    flex-wrap: wrap;
    justify-content: space-between;
  `,
  Top: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  `
}
